import { createFileRoute } from "@tanstack/react-router";

import UserPage from "@/features/users/user";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute("/_auth/_app-shell/users/$userId/edit")({
  component: RouteComponent,
});

function RouteComponent() {
  usePageTitle("User");

  return <UserPage />;
}
